export default {"src":"/_next/static/media/icone-helio.639a58ed.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};